import { render, staticRenderFns } from "./billInstall.vue?vue&type=template&id=3d34a132&scoped=true&"
import script from "./billInstall.vue?vue&type=script&lang=ts&"
export * from "./billInstall.vue?vue&type=script&lang=ts&"
import style0 from "./billInstall.vue?vue&type=style&index=0&id=3d34a132&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34a132",
  null
  
)

component.options.__file = "billInstall.vue"
export default component.exports